import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import { lenisRef } from "@/lib/lenis";
import Home from "@/pages/Home";
import Prestazioni from "@/pages/Prestazioni";
import Centro from "@/pages/Centro";
import Team from "@/pages/Team";
import Recensioni from "@/pages/Recensioni";
import Faq from "@/pages/Faq";
import Prenota from "@/pages/Prenota";
import Privacy from "@/pages/Privacy";
import CookiePolicy from "@/pages/CookiePolicy";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ smoothWheel: true, lerp: 0.09 });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/prestazioni" element={<Prestazioni />} />
            <Route path="/il-centro" element={<Centro />} />
            <Route path="/team" element={<Team />} />
            <Route path="/recensioni" element={<Recensioni />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/prenota" element={<Prenota />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
